// extracted by mini-css-extract-plugin
module.exports = {"vGray10":"#cfd4dd","footer":"MessengerFooter_footer__Nq_Le"};